<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter">Contents</p>
<p><a href="#/OEBPS/acknow.htm">Acknowledgments</a><br/><br/></p>
<p><a href="#/OEBPS/source.htm">Sources</a><br/><br/></p>
<p><a href="#/OEBPS/intro.htm">Introduction: Stalin’s Absolute Control, Misconceptions, and Disastrous Decisions</a><br/><br/></p>
<p><a href="#/OEBPS/abbr.htm">Abbreviations and Acronyms<br/></a><br/><br/></p>
<p><a href="#/OEBPS/ch01.htm"><span class="small"><b>CHAPTER 1</b></span> Stalin versus Hitler: Background</a><br/><br/></p>
<p><a href="#/OEBPS/ch02.htm"><span class="small"><b>CHAPTER 2</b></span> The Outspoken General: Ivan Iosifovich Proskurov</a><br/><br/></p>
<p><a href="#/OEBPS/ch03.htm"><span class="small"><b>CHAPTER 3</b></span> Proskurov Sets Stalin Straight</a><br/><br/></p>
<p><a href="#/OEBPS/ch04.htm"><span class="small"><b>CHAPTER 4</b></span> Soviet Borders Move Westward</a><br/><br/></p>
<p><a href="#/OEBPS/ch05.htm"><span class="small"><b>CHAPTER 5</b></span> The Finns Fight: Proskurov Made a Scapegoat</a><br/><br/></p>
<p><a href="#/OEBPS/ch06.htm"><span class="small"><b>CHAPTER 6</b></span> Soviet Military Intelligence Residencies in Western Europe</a><br/><br/></p>
<p><a href="#/OEBPS/ch07.htm"><span class="small"><b>CHAPTER 7</b></span> Soviet Military Intelligence Residencies in Eastern Europe</a><br/><br/></p>
<p><a href="#/OEBPS/ch08.htm"><span class="small"><b>CHAPTER 8</b></span> Who Were You, Dr. Sorge? Stalin Never Heard of You.</a><br/><br/></p>
<p><a href="#/OEBPS/ch09.htm"><span class="small"><b>CHAPTER 9</b></span> NKVD Foreign Intelligence</a><br/><br/></p>
<p><a href="#/OEBPS/ch10.htm"><span class="small"><b>CHAPTER 10</b></span> Fitin’s Recruited Spies</a><br/><br/></p>
<p><a href="#/OEBPS/ch11.htm"><span class="small"><b>CHAPTER 11</b></span> Listening to the Enemy</a><br/><br/></p>
<p><a href="#/OEBPS/ch12.htm"><span class="small"><b>CHAPTER 12</b></span> Working on the Railroad</a><br/><br/></p>
<p><a href="#/OEBPS/ch13.htm"><span class="small"><b>CHAPTER 13</b></span> The Border Troops Knew</a><br/><br/></p>
<p><a href="#/OEBPS/ch14.htm"><span class="small"><b>CHAPTER 14</b></span> Proskurov Is Fired</a><br/><br/></p>
<p><a href="#/OEBPS/ch15.htm"><span class="small"><b>CHAPTER 15</b></span> Golikov and Operation Sea Lion</a><br/><br/></p>
<p><a href="#/OEBPS/ch16.htm"><span class="small"><b>CHAPTER 16</b></span> “We Do Not Fire on German Aircraft in Peacetime”</a><br/><br/></p>
<p><a href="#/OEBPS/ch17.htm"><span class="small"><b>CHAPTER 17</b></span> German Deception: Why Did Stalin Believe It?</a><br/><br/></p>
<p><a href="#/OEBPS/ch18.htm"><span class="small"><b>CHAPTER 18</b></span> Secret Letters</a><br/><br/></p>
<p><a href="#/OEBPS/ch19.htm"><span class="small"><b>CHAPTER 19</b></span> The Purges Revived</a><br/><br/></p>
<p><a href="#/OEBPS/ch20.htm"><span class="small"><b>CHAPTER 20</b></span> On the Eve</a><br/><br/></p>
<p><a href="#/OEBPS/ch21.htm"><span class="small"><b>CHAPTER 21</b></span> A Summer of Torture</a><br/><br/></p>
<p><a href="#/OEBPS/ch22.htm"><span class="small"><b>CHAPTER 22</b></span> The Final Reckoning<br/></a><br/></p>
<p><a href="#/OEBPS/conclusion.htm">Conclusion: Will the Future Be a Repeat of the Past?</a><br/><br/></p>
<p><a href="#/OEBPS/app1.htm">Appendix 1: Organization and Functions of Soviet Military Intelligence</a><br/><br/></p>
<p><a href="#/OEBPS/app2.htm">Appendix 2: Hitler’s Letters to Stalin</a><br/><br/></p>
<p><a href="#/OEBPS/app3.htm">Appendix 3: Those Executed without Trial on October 28, 1941</a><br/><br/></p>
<p><a href="#/OEBPS/app4.htm">Appendix 4: Chronology of Agent Reporting</a><br/><br/></p>
<p><a href="#/OEBPS/glossary.htm">Glossary of Spies and Their Masters</a><br/><br/></p>
<p><a href="#/OEBPS/note.htm">Notes</a><br/><br/></p>
<p><a href="#/OEBPS/index.htm">Index</a><br/><br/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?0f6b88d6